import { render, staticRenderFns } from "./DepNeurosurgery.vue?vue&type=template&id=6f894346&scoped=true&"
import script from "./DepNeurosurgery.vue?vue&type=script&lang=js&"
export * from "./DepNeurosurgery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f894346",
  null
  
)

export default component.exports